<template>
  <div
    class="detail_main">
    <div @click="$parent.show = false" class="detail_container"
      :class="{'bg_detail': bg}">
    </div>
      <section
        class="size_detail zero_right margin_top_detail padding_bottom_detail has-background-white">
        <div class="columns is-marginless is-marginless detail_content
                    detail_content_bg  max-height">
          <a @click="$parent.show = false"
            class="detail_icon_close_right topVert">
            <b-icon
              icon="window-close"
              type="is-white">
            </b-icon>
          </a>
          <img :src="url" class="imageDetail" alt="">
        </div>
        <div class="columns is-marginless detail_content is-marginless">
          <div class="half_width topVert leftVert rightVert">
            <h3 class="has-text-weight-bold has-text-link bottomVert">
              Caractéristiques:</h3>
            <div class="columns is-marginless is-multiline color-icon">
              <div class="column is-6 is-paddingless bottomViolet" v-if="detailFace.facCode">
                <div class="media">
                  <b-icon
                    icon="barcode"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-dark is-size-7">
                      <label class="has-text-default">
                        Code face
                      </label><br>
                      <p class="p_size14 has-text-weight-bold">
                        {{detailFace.facCode ? detailFace.facCode : detailFace.code}}
                      </p>
                  </div>
                </div>
              </div>
              <div class="column is-6 is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="panorama-wide-angle"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-dark is-size-7">
                      <label class="has-text-default">
                        Panneau
                      </label><br>
                      <p class="p_size14 has-text-weight-bold">
                        {{detailFace.panCode ? detailFace.panCode : detailFace.panCote}}
                      </p>
                  </div>
                </div>
              </div>
              <div class="column is-6 is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="vector-intersection"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-dark is-size-7">
                      <label class="has-text-default">
                        Format
                      </label><br>
                      <p class="p_size14 has-text-weight-bold">
                        {{detailFace.format}}
                      </p>
                  </div>
                </div>
              </div>
              <div
                v-if="detailFace.materiel"
                class="column is-6 is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="package-variant-closed"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-dark is-size-7">
                      <label class="has-text-default">
                        Matériel
                      </label><br>
                      <p class="p_size14 has-text-weight-bold">
                        {{detailFace.materiel}}
                      </p>
                  </div>
                </div>
              </div>
              <div
                v-if="detailFace.support"
                class="column is-6 is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="sign-text"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-dark is-size-7">
                      <label class="has-text-default">
                        Support
                      </label><br>
                      <p class="p_size14 has-text-weight-bold">
                        {{detailFace.support}}
                      </p>
                  </div>
                </div>
              </div>
              <div
                class="column is-6 is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="lightbulb-on-outline"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-dark is-size-7">
                      <label class="has-text-default">
                        Éclairé
                      </label><br>
                      <p class="p_size14 has-text-weight-bold">
                        {{eclaire}}
                      </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="half_width topVert rightVert">
            <h3 class="has-text-weight-bold has-text-dark bottomVert">Visibilité:</h3>
            <div class="columns is-marginless is-multiline color-icon">
              <div class="column is-6 is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="map-marker-circle"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-dark is-size-7">
                      <label class="has-text-default">
                        Localisation
                      </label><br>
                      <p class="p_size14 has-text-weight-bold">
                        {{detailFace.localisation ?
                          detailFace.localisation :
                          'Non renseignée'}}
                      </p>
                  </div>
                </div>
              </div>
              <div class="column is-6 is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="angle-obtuse"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-dark is-size-7">
                      <label class="has-text-default">
                        Angle de vision
                      </label><br>
                      <p class="p_size14 has-text-weight-bold">
                        {{detailFace.angleDeVision ?
                          detailFace.angleDeVision :
                          'Non renseignée'}}
                      </p>
                  </div>
                </div>
              </div>
              <div class="column is-6 is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="arrow-right"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-dark is-size-7">
                      <label class="has-text-default">
                        En venant de
                      </label><br>
                      <p class="p_size14 has-text-weight-bold">
                        {{detailFace.enVenantDe ?
                          detailFace.enVenantDe :
                          'Non renseignée'}}
                      </p>
                  </div>
                </div>
              </div>
              <div class="column is-6 is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="arrow-left"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-dark is-size-7">
                      <label class="has-text-default">
                        En allant vers
                      </label><br>
                      <p class="p_size14 has-text-weight-bold">
                        {{detailFace.enAllantVers ?
                          detailFace.enAllantVers :
                          'Non renseignée'}}
                      </p>
                  </div>
                </div>
              </div>
              <div
                v-if="adresse"
                class="column is-paddingless">
                <div class="media">
                  <b-icon
                    icon="map-marker"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-dark is-size-7">
                      <label class="has-text-default">
                        Adresse
                      </label><br>
                      <p class="p_size14 has-text-weight-bold">
                        {{adresse}}
                      </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  </div>
</template>

<script>
import { urlPhoto, formatEclaire, formatAdresse } from '@/services/opportunite/formatTab';

export default {
  name: 'detailReseauxPersonnaliseComplet',
  props: ['detailFace', 'bg'],
  data() {
    return {
      select: true,
    };
  },
  computed: {
    url() {
      return urlPhoto(this.detailFace.urlPhoto);
    },
    eclaire() {
      return formatEclaire(this.detailFace.eclaire);
    },
    adresse() {
      return formatAdresse(this.detailFace);
    },
  },
  mounted() {
    const test = document.querySelector('html');
    test.style.overflow = 'hidden';
  },
  destroyed() {
    const test = document.querySelector('html');
    test.style.overflow = '';
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/reseauxPersonnalise/detailReseauxPersonnaliseComplet.vue